import {
  CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING,
  CAMPAIGN_ON_BOARDING,
  CONTENT_EXPLORER_ONBOARDING,
  EMAIL_BROWSER_ON_BOARDING,
  USER_ACCOUNT_DETAILS,
  USER_DETAILS,
} from "constants/types";
import { LOGIN } from "../../constants/actionTypes";

const initialUserState = {
  // userData: {} as Interfaces.IUser,
  userData: {} as any,
  xiq_internal_user: false,
  isPremium: true,
  isClickedAmazing: false,
  isAssetBrowserPopupNotShowAgain: false,
  isTooltipAlreadyShowedFirstTime: false,
  isBrowseGillRoyFirstTime: false,
  showAssetBrowserPopup: false,
  // campaignAndEmails: 0,
  // campaignAndEmailsStep: 0,
  // campaignAudience: 0,
  // campaignAudienceStep: 0,
  // campaignAudienceDashboard: 0,
  // campaigns: 0,
  // campaignsStep: 0,
  // campaignsSmartSource: 0,
  // campaignsSmartSourceStep: 0,
  // contentAssetBrowser: 0,
  // contentExplorer: 0,
  // contentExplorerStep: 0,
  // editions: 0,
  // editionStep: 0,
  // assetSmartSource: 0,
  // assetSmartSourceStep: 0,
  // assets: 0,
  // assetsStep: 0,
  // editionSmartSource: 0,
  // editionSmartSourceStep: 0,
  has_share_profile_perm: false,
  has_daily_iq_perm: false,
  has_weekly_account_insight_perm: false,
  planType: "",
  accountDetails: {} as any,
};

// export const loginReducer = (state = initialUserState, action: Interfaces.IUserAction) => {
export const loginReducer = (state = initialUserState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case LOGIN.LOAD_SUCCESS:
      newState.userData = action.payload;
      newState.isBrowseGillRoyFirstTime = action.payload.first_login_workbench === 1 ? true : false;
      return newState;
    case LOGIN.TURN_OFF_FIRST_LOGIN:
      newState.userData.first_login_workbench = 0;
      return newState;
    case USER_DETAILS.LOAD:
      return newState;
    // When user clicks on Gill Roy "Amazing button call api and hide it"
    case USER_DETAILS.CLICKED_AMAZING:
      newState.isClickedAmazing = true;
      return newState;
    case USER_DETAILS.SET_DO_NOT_SHOW_ASSET_BROWSER_POPUP:
      newState.isAssetBrowserPopupNotShowAgain = true;
      return newState;
    case USER_DETAILS.SHOW_TOOL_TIP_FIRST_TIME:
      newState.showAssetBrowserPopup = true;
      newState.isTooltipAlreadyShowedFirstTime = true;
      return newState;

    case USER_DETAILS.HIDE_TOOL_TIP_FIRST_TIME:
      newState.showAssetBrowserPopup = false;
      return newState;

    case USER_DETAILS.SUCCESS:
      let userData: any = {};
      userData.firstName = action.payload.first_name;
      userData.lastName = action.payload.last_name;
      userData.userId = action.payload.user_id;
      userData.userEmail = action.payload.user_email;
      newState.userData = { ...newState.userData, ...action.payload, ...userData };
      // newState.campaignAudience = action.payload.campaign_audience;
      // newState.campaignAudienceStep = action.payload.campaign_audience_step;
      // newState.campaignAudienceDashboard = action.payload.campaign_audience_dashboard;
      // newState.campaigns = action.payload.campaigns;
      // newState.campaignsStep = action.payload.campaigns_step;
      // newState.campaignAndEmails = action.payload.campaigns_and_emails;
      // newState.campaignAndEmailsStep = action.payload.campaigns_and_emails_step;
      // newState.campaignsSmartSource = action.payload.campaigns_smart_source;
      // newState.campaignsSmartSourceStep = action.payload.campaigns_smart_source_step ?? 1;
      // newState.contentAssetBrowser = action.payload.content_asset_browser;
      // newState.contentExplorer = action.payload.content_explorer;
      // newState.contentExplorerStep = action.payload.content_explorer_step;
      // newState.editionSmartSource = action.payload.edition_smart_source;
      // newState.editionSmartSourceStep = action.payload.edition_smart_source_step;
      // newState.editions = action.payload.editions;
      // newState.editionStep = action.payload.edition_step;
      // newState.assetSmartSource = action.payload.asset_smart_source;
      // newState.assetSmartSourceStep = action.payload.asset_smart_source_step;
      // newState.assets = action.payload.assets;
      // newState.assetsStep = action.payload.assets_step;
      newState.isAssetBrowserPopupNotShowAgain = !action.payload.show_msg;
      newState.xiq_internal_user = action.payload.xiq_internal_user;
      newState.has_share_profile_perm = action.payload.has_share_profile_perm;
      newState.has_daily_iq_perm = action.payload.has_daily_iq_perm;
      newState.has_weekly_account_insight_perm = action.payload.has_weekly_account_insight_perm;
      newState.planType = String(action.payload.plan_type).toUpperCase();
      return newState;

    case USER_DETAILS.RESET:
      return newState;

    case USER_DETAILS.SET_PLAN_TYPE:
      newState.planType = action.planType;
      return newState;

    // on boarding

    // case CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING.SET_STEP:
    //   newState.campaignAndEmails = action.payload.value;
    //   newState.campaignAndEmailsStep = action.payload.step;
    //   return newState;

    // case CONTENT_EXPLORER_ONBOARDING.SET_STEP:
    //   newState.contentExplorer = action.payload.value;
    //   newState.contentExplorerStep = action.payload.step;
    //   return newState;

    // case CAMPAIGN_ON_BOARDING.DASHBOARD_SET_STEP:
    //   newState.campaigns = action.payload.value;
    //   newState.campaignsStep = action.payload.step;
    //   return newState;

    // case CAMPAIGN_ON_BOARDING.SMART_SOURCE_SET_STEP:
    //   newState.campaignsSmartSource = action.payload.value;
    //   newState.campaignsSmartSourceStep = action.payload.step;
    //   return newState;

    // case CAMPAIGN_ON_BOARDING.AUDIENCE_SET_STEP:
    //   newState.campaignAudience = action.payload.value;
    //   newState.campaignAudienceStep = action.payload.step;
    //   return newState;

    // case EMAIL_BROWSER_ON_BOARDING.SET_SHOW:
    //   newState.assets = action.payload.value;
    //   return newState;

    // * User Account Details Reducer

    case USER_ACCOUNT_DETAILS.LOAD:
      return newState;
    case USER_ACCOUNT_DETAILS.SUCCESS:
      newState.accountDetails = action.payload;
      return newState;
    case USER_ACCOUNT_DETAILS.RESET:
      newState.accountDetails = {};
      return newState;
    case USER_ACCOUNT_DETAILS.FAIL:
      return newState;

    default:
      return newState;
  }
};
